import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useState } from "react";

import { Button, Flex, Input } from "antd";

import { useNavigate } from "react-router-dom";
import useMetaData from "../../../../../hooks/useMetaData";
import useKeyword from "../../../../../hooks/useKeyword";
import { IndustryInfo } from "../../../../../types/course";
import Banner from "../../../../../components/banner/Banner";
import { concatQueryString } from "../../../../../utils/app";

function SearchBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { allIndustry } = useMetaData();
  const topicId = Number(useKeyword("topic"));
  const currentSearch = location.search;
  const currentIndustry = allIndustry?.find(
    (item: IndustryInfo) => item.id === topicId
  );
  const [keySearch, setKeySearch] = useState(useKeyword("keyword") || "");

  const renderTitle = () => {
    if (currentIndustry)
      return <span>{t("Các khoá học về", "Các khoá học về")} {currentIndustry.name}</span>;

    return t("Tất cả khoá học", "Tất cả khoá học");
  };

  const onKeyBoardEnter = (e: any) => {
    if (e.key === "Enter") {
      handleClickSearch();
    }
  };

  const handleClickSearch = () => {
    if (keySearch) {
      const newQueryString = concatQueryString(
        currentSearch,
        "keyword",
        keySearch
      );
      navigate(`${window.location.pathname}?${newQueryString}`);
    } else {
      navigate(`${window.location.pathname}`);
    }
  };

  return (
    <Banner className="bg-white">
      <section className="center flex-column course-info-banner-content">
        <span className="mb-2 font-size-18">{t("Danh sách khoá học", "Danh sách khoá học")}</span>
        <div className="container">
          <h3 className="mb-3 banner-title text-center font-size-48">{renderTitle()}</h3>
        </div>
        <span className="mb-4 font-size-20">
          {t("Với 1000+ các khoá học với nhiều chủ đề khác nhau", "Với 1000+ các khoá học với nhiều chủ đề khác nhau")}
        </span>

        <Flex className="search" align="center" gap={8}>
          <Input
            className="search-input"
            value={keySearch}
            onKeyDown={onKeyBoardEnter}
            onChange={(e) => setKeySearch(e.target.value)}
            placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
            allowClear
          />
          <Button
            className="mooc-btn-violet btn-private-primary search-input"
            onClick={handleClickSearch}
          >{t("Tìm kiếm", "Tìm kiếm")}</Button>
        </Flex>
      </section>
    </Banner>
  );
}

export default SearchBanner;
